import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class UploadTypeImgCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUploadTypeImgCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/{transportTypeId}/uploadImg';
  public override setParameters(parameters: IUploadTypeImgCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{transportTypeId}',
      parameters.transportTypeId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUploadTypeImgCommandParameters
  extends ICommandParameters {
  transportTypeId: number;
  carrierId: string;
  imageBase64: string,
  order: number
}
